const FormHelper = (instance) => {
    return {
        onChange: (e) => {
            if (e.target.type === 'checkbox') {
                instance.setState({
                    ...instance.state,
                    rememberMe: !instance.state.rememberMe
                })
            }
            else if (e.target.type === 'file') {
                const file = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null
                instance.setState({
                    ...instance.state,
                    [e.target.name]: file
                })
            }
            else {
                instance.setState({
                    ...instance.state,
                    [e.target.name]: e.target.value
                })
            }
        }
    }
}

export default FormHelper
